<template>
    <div class="siteprogram">
        <Nav ref="Nav" />
        <div class="writing_right">
            <div class="TitleList">
                <div class="TitleList_padding">
                    <div class="TitleList_top">
                        <div class="TitleList_top_title">
                            <div class="top_title_dd"><span></span>选择站点所使用的程序</div>
                            <div class="top_title_dt">请选择站点所使用的程序或平台，点击开始创建。</div>
                        </div>
                        <div class="TitleList_top_btn">
                            <button @click="goOff()"><i class="el-icon-back"></i>返回</button>
                        </div>
                    </div>
                </div>
                <div class="siteprogram_content">
                    <router-link :to="'/writing/siteManagement/parameterSettings?id=' + info.id" class="siteprogram_content_list" v-for="(info, index) in infos" :key="index">
                        <div class="siteprogram_content_list_icon">
                            <div class="list_icon_dd"><img :src="info.logo_image" /></div>
                            <div class="list_icon_dt">开始创建</div>
                        </div>
                        <div class="siteprogram_content_list_title">{{info.name}}</div>
                    </router-link>
                    <div class="siteprogram_content_not">没有您的站点？<a href="https://work.weixin.qq.com/kfid/kfc93ed84ae79165746" target="_blank">立即联系客服</a>协助你开发。</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Nav from "@c/common/nav/nav";

    export default {
        name: "siteprogram",
        data() {
            return {
                showLog: false,
                infos: [

                ],
            };
        },
        components: {
            Nav
        },
        methods:{
			//点击触发ai套餐
			triggerChildMethod() {
			this.$refs.Nav.childMethod();
			},
            goOff(){
                this.$router.go(-1);
            },
            getList(){
              let that = this;
              that.axios.get('/api/site/listDemo').then(res => {
                if(res.code === 1) {
                  that.infos = res.result

                }
              })
            }
        },
        mounted() {
            this.getList()
        },
    }
</script>

<style>
  @import "sitEprogram.css";
</style>
